export const iconFontAwesomeMapsTag = (
	<i className="fa-solid fa-tag"></i>
);
